export const FILE_NAV_ID = 'FILE';

export enum FileKind {
  PDF = 'pdf',
  IMAGE = 'image',
  UNSUPPORTED = 'unsupported'
}

export const PDF_EXTENSIONS = ['pdf'];

export const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png'];

export const PDF_MIME_TYPE = 'application/pdf';

export const FileChartText = {
  CHART_SECTION: 'Special Charts',
  LOAD_ERROR: 'This file could not be displayed. The link may have expired.',
  UNSUPPORTED: 'This file type cannot be previewed.',
  MISSING_URL: 'This file is not available. No file link was saved for this chart.',
  OPEN_IN_NEW_TAB: 'Open file in a new tab'
};
